<template>
  <a-card :bordered='false'>
    <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="currentFormLayout2.labelCol"
                  :wrapper-col="currentFormLayout2.wrapperCol">
      <a-form-model-item label="当前防控等级" prop="policyLevel">
        <a-input v-model.trim="ruleForm.policyLevel" allowClear :maxLength="50"
                 placeholder="请输入当前防控等级"></a-input>
      </a-form-model-item>
      <a-form-model-item label="进入防疫政策" prop="inPolicy">
        <CustomUeditor v-model="ruleForm.inPolicy"></CustomUeditor>
      </a-form-model-item>
      <a-form-model-item label="离开防疫政策" prop="outPolicy">
        <CustomUeditor v-model="ruleForm.outPolicy"></CustomUeditor>
      </a-form-model-item>
      <a-form-model-item label="疫情防控咨询电话" prop="policyPhone">
        <CustomUeditor v-model="ruleForm.policyPhone"></CustomUeditor>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading" style="width: 180px;">保存设置
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import GuWeiMixins from '@/views/service/serviceProvider/guWei/mixins/GuWeiMixins'
import CustomUeditor from '@/customComponents/CustomUeditor/CustomUeditor'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'GuWeiPolicy',
  mixins: [GuWeiMixins, ruleFormMixins],
  components: {
    CustomUeditor
  },
  props: {},
  data() {
    return {
      submitLoading: false,
      ruleForm: {
        id: undefined,
        inPolicy: '',// 进入防疫政策 ,
        merchantId: this.$store.getters.userInfo.merchantId,// 商户ID ,
        outPolicy: '',// 离开防疫政策 ,
        platformId: this.getPlatformConfig().platformId,// 平台ID ,
        policyLevel: '',// 当前防控等级 ,
        policyPhone: ''// 疫情防控咨询电话
      },
      rules: {
        policyLevel: [{ required: true, message: '请输入当前防控等级', trigger: 'blur' }],
        inPolicy: [{ required: true, message: '请输入进入防疫政策', trigger: 'blur' }],
        outPolicy: [{ required: true, message: '请输入离开防疫政策', trigger: 'blur' }],
        policyPhone: [{ required: true, message: '请输入疫情防控咨询电话', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getPolicyDetail()
  },
  methods: {
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      params.merchantId = this.$store.getters.userInfo.merchantId// 商户ID ,
      params.platformId = this.getPlatformConfig().platformId// 平台ID ,
      this.getHttpServices().getServerApiService().post('api/gw/policy/save', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('防疫政策保存成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    getPolicyDetail() {
      const params = {
        merchantId: this.$store.getters.userInfo.merchantId,// 商户ID ,
        platformId: this.getPlatformConfig().platformId// 平台ID ,
      }
      this.getHttpServices().getServerApiService().post('api/gw/policy/detail', params).then(res => {
        this.ruleForm = { ...res }
      }).catch(err => {
        this.getLogUtils().logWithTag(err)
      })
    }
  }
}
</script>

<style scoped lang='less'>

</style>
